export default __webpack_public_path__ + "f2a309231859cf6d82399da7939c48b4.png";